function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import InAppMessage from "./models/in-app-message.js";
import ControlMessage from "./models/control-message.js";
import FullScreenMessage from "./models/full-screen-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import ModalMessage from "./models/modal-message.js";
import SlideUpMessage from "./models/slide-up-message.js";
import { logger as N } from "../../shared-lib/index.js";
export function newInAppMessageFromJson(e) {
  if (!e) return null;
  if (e.is_control) return ControlMessage.fromJson(e);
  var o = e.type;
  null != o && (o = o.toUpperCase());
  var s = e.message,
      n = e.text_align_message,
      r = e.slide_from,
      t = e.extras,
      m = e.trigger_id,
      l = e.click_action,
      i = e.uri,
      f = e.open_target,
      p = e.message_close,
      u = e.duration,
      a = e.icon,
      d = e.image_url,
      g = e.image_style,
      c = e.icon_color,
      j = e.icon_bg_color,
      w = e.bg_color,
      b = e.text_color,
      h = e.close_btn_color,
      v = e.header,
      x = e.text_align_header,
      I = e.header_text_color,
      A = e.frame_color,
      F = [];
  var M = e.btns;
  null == M && (M = []);

  for (var _e = 0; _e < M.length; _e++) {
    F.push(InAppMessageButton.fromJson(M[_e]));
  }

  var k = e.crop_type,
      y = e.orientation,
      z = e.animate_in,
      J = e.animate_out;
  var S = e.html_id,
      q = e.css;
  null != S && "" !== S && null != q && "" !== q || (S = void 0, q = void 0);
  var B = e.message_extras;
  var C;
  if (o === ModalMessage.cs || o === InAppMessage.bo.Fo) C = new ModalMessage(s, n, t, m, l, i, f, p, u, a, d, g, c, j, w, b, h, z, J, v, x, I, A, F, k, S, q, B);else if (o === FullScreenMessage.cs) C = new FullScreenMessage(s, n, t, m, l, i, f, p, u, a, d, g, c, j, w, b, h, z, J, v, x, I, A, F, k, y, S, q, B);else if (o === SlideUpMessage.cs) C = new SlideUpMessage(s, n, r, t, m, l, i, f, p, u, a, d, c, j, w, b, h, z, J, S, q, B);else {
    if (o !== HtmlMessage.cs && o !== InAppMessage.bo.po && o !== InAppMessage.bo.Jo) return void N.error("Ignoring message with unknown type " + o);
    {
      var _o = e.message_fields;
      C = new HtmlMessage(s, t, m, p, u, z, J, A, S, q, _o, B), C.trusted = e.trusted || !1;
    }
  }
  return C.uo = o, C;
}
export function buttonsFromSerializedInAppMessage(e) {
  var o = [];

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      o.push(new InAppMessageButton(s.text, s.backgroundColor, s.textColor, s.borderColor, s.clickAction, s.uri, s.id));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return o;
}